import Image from "next/image";
import { Card, CardContent } from "../ui/card";
import { RatingIcon } from "../../../public/icons";

interface iProps {
  description: string;
  imgUrl: string;
  name: string;
  title: string;
  rating: number;
}

const SliderContent: React.FC<iProps> = ({
  description,
  imgUrl,
  name,
  title,
  rating,
}) => {
  return (
    <Card className="bg-[#FCFAF4] max-w-[400px] w-full h-[223px] flex">
      <CardContent className="lg:p-6 p-4 sm:p-5 h-full flex flex-col flex-grow">
        {/* Rating */}
        <div className="flex gap-1 mb-4">
          {[...Array(5)].map((_, index) => (
            <div
              className={index < rating ? "text-[#F35656]" : "text-[#FFD3D3]"}
              key={index}
            >
              <RatingIcon />
            </div>
          ))}
        </div>

        {/* Description */}
        <p className="font-semibold lg:text-base sm:text-sm text-base text-[#022329] mb-4 flex-grow">
          {description}
        </p>

        <div className="flex gap-3 items-center mt-auto">
          <Image
            alt="Testimony person image"
            height={48}
            width={48}
            src={imgUrl}
            className="w-12 h-12 rounded-full"
          />
          <div>
            <p className="font-bold sm:text-base ext-sm text-[#022329] mb-[2px]">
              {name}
            </p>
            <p className="font-medium text-xs sm:text-sm text-[#6B7280] italic">
              {title}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SliderContent;
